import {Translatable, TranslationKey} from 'common/i18n';
import {CohortSegment} from 'common/query-builder/query-block/segment-menu/types';

export enum LiftType {
  Time = `timeComparison`,
  Overall = `percentOverall`,
  Segment = `segment`,
  Experiment = `experiment`,
}

export const TIME_COMPARE_NON_LIFT_KEY = `time`;

// Currently the same as the display name, but those may change and we want tracking to stay static
export const LiftTypeTrackingName: {[key in LiftType | typeof TIME_COMPARE_NON_LIFT_KEY]: string} = {
  [TIME_COMPARE_NON_LIFT_KEY]: `time`,
  [LiftType.Time]: `timeLift`,
  [LiftType.Overall]: `overall`,
  [LiftType.Segment]: `segment`,
  [LiftType.Experiment]: `experiment`,
};

export const LIFT_TRACKING_PREFIX = `report info: lift comparison type`;

/*
 * Long-form name of a Lift Type.
 * Used in tooltips, e.g. "Pie chart is not available with overall comparison"
 */
export const LiftTypeDescriptionKey: {[key in LiftType]: TranslationKey} = {
  [LiftType.Time]: `reports.lift-comparison.period-description`,
  [LiftType.Overall]: `reports.lift-comparison.segment-description`,
  [LiftType.Segment]: `reports.lift-comparison.overall-description`,
  [LiftType.Experiment]: `reports.lift-comparison.experiment-description`,
};

export const LiftTypeDisabledKey: {[key in LiftType]: TranslationKey} = {
  [LiftType.Time]: `reports.chart-types.disabled-reasons.percent-change`,
  [LiftType.Overall]: `reports.chart-types.disabled-reasons.overall-comparison`,
  [LiftType.Segment]: `reports.chart-types.disabled-reasons.segment-comparison`,
  [LiftType.Experiment]: `reports.chart-types.disabled-reasons.experiment-comparison`,
};

export const LIFT_TOOLTIP_COMPARE = `compared to`;

/*
 * Represents an option to display when showing "Segment" comparison.
 * Can be a cohort or a property value.
 */
export interface SegmentLiftBaselineOption {
  displayName: string;
  cohortSegment?: CohortSegment;
  propertyValue?: string;
}

export interface LiftTypeEnabledState {
  enabled: boolean;
  reason?: Translatable;
}

export interface LiftTypeOverrides {
  [LiftType.Segment]?: LiftTypeEnabledState;
  [LiftType.Overall]?: LiftTypeEnabledState;
  [LiftType.Time]?: LiftTypeEnabledState;
  [LiftType.Experiment]?: LiftTypeEnabledState;
}
